
import { useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';
import { SubscriptionFeatures } from '@/lib/types';

export function useFeatureAccess() {
  const { features, hasFeature, isLoading } = useFeatureFlags();
  
  // Memoize all feature checks to prevent unnecessary recalculations
  const featureAccess = useMemo(() => ({
    canUseCurrencyConversion: hasFeature('currency_conversion'),
    canUseMultipleCurrencies: hasFeature('multiple_currencies'),
    canUsePriceComparison: hasFeature('price_comparison'),
    canUseGroupedContracts: hasFeature('grouped_contracts'),
    canUseContractServices: hasFeature('contract_services'),
    canUseReminders: hasFeature('reminders'),
    canUsePaymentTypeSelection: hasFeature('payment_type_selection'),
    canUseDashboard: hasFeature('dashboard')
  }), [hasFeature]);

  return {
    isLoading,
    features,
    hasFeature,
    ...featureAccess
  };
}
